import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { useOrganization } from "hooks";
import Card from "components/Card";
import DisplayBox from "components/DisplayBox";

/**
 * OrganizationApplicationPIN
 *
 * @param {String} id - Organization ID
 */
const OrganizationApplicationPIN = ({ id, ...props }) => {
  const { data, loading, error } = useOrganization({ id });

  return (
    <Card>
      <DisplayBox
        title={<FormattedMessage id="Organization.OrganizationsApplicationPIN.Title" />}
        description={<FormattedMessage id="Organization.OrganizationsApplicationPIN.Description" />}
        numColumns={10} // To reduce the loading skeleton width
        data={APPLICATION_PIN_DATA(data)}
        loading={loading}
        error={error}
        {...props}
      />
    </Card>
  );
};

const APPLICATION_PIN_DATA = (data) => [
  {
    title: "PIN",
    body: data?.applicationsPin,
  },
];

OrganizationApplicationPIN.propTypes = {
  id: PropTypes.string.isRequired,
};

export default OrganizationApplicationPIN;
